import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import contentReducer from './contentReducer';
import dataReducer from './dataReducer';
import editorStateReducer from './editorStateReducer';

function rootReducer(state, action) {
  switch (action.type) {
    case 'reset':
      return {
        content: action.payload,
        editorState: {
          serverContent: action.payload
        },
        undoStates: [],
        redoStates: []
      };

    case 'undo':
      if (state.undoStates.length === 0) throw new Error('Undo states is empty.');
      return _objectSpread({}, state, {
        content: state.undoStates[state.undoStates.length - 1],
        redoStates: [].concat(_toConsumableArray(state.redoStates), [state.content]),
        undoStates: state.undoStates.slice(0, state.undoStates.length - 1)
      });

    case 'redo':
      if (state.redoStates.length === 0) throw new Error('Redo states is empty.');
      return _objectSpread({}, state, {
        content: state.redoStates[state.redoStates.length - 1],
        undoStates: [].concat(_toConsumableArray(state.undoStates), [state.content]),
        redoStates: state.redoStates.slice(0, state.redoStates.length - 1)
      });

    case 'error':
      return _objectSpread({}, state, {
        error: action.payload
      });

    default:
      {
        var newState = _objectSpread({}, state, {
          content: contentReducer(state.content, action),
          data: dataReducer(state.data, action),
          editorState: editorStateReducer(state.editorState, action)
        }); // widget preview should not be included in the undo redo states


        if (action.type !== 'change_widget_property' || action.payload.propertyName !== 'widgetPreview') {
          // add to undo state whenever a change is occured via content reducer
          if (state.content != newState.content) {
            newState.undoStates.push(state.content);
            newState.redoStates = [];
          }
        }

        return newState;
      }
  }
}

export default rootReducer;